// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"1993":"391503c588ff25d6","6992":"773acc125dd3522e"}[chunkId] + ".js";
};